import { createFileRoute } from '@tanstack/react-router'
import { DocumentsSettings } from '@/features/settings/documents-settings'

export const Route = createFileRoute('/_layout/_app/settings/documents/$')({
  component: function DocumentsSettingsSplat() {
    const { _splat } = Route.useParams()
    return <DocumentsSettings folderPath={_splat ?? ''} />
  },
})
